(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-on-comparison"] && !Shopify.designMode) return;
  try {
    
/* Native custom element: no dependencies, isolated instances, theme-editor safe. */
(() => {
  if (customElements.get('pop-on-comparison-v4')) return;
  class PopOnComparison extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      // A parser may connect the custom element before its children exist.
      if (!this.querySelector('.pc-modal')) {
        this._startupFrame = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
        return;
      }
      this._ready = true;
      this._abort = new AbortController();
      this._carousels = new Map();
      this._objectURLs = new Set();
      this._boundRows = new WeakSet();
      this._boundTracks = new WeakSet();
      this._rows = [];
      this._dialog = this.querySelector('.pc-modal');
      this._lastFocus = null;
      this._currentCards = [];
      this._currentIndex = 0;
      const signal = this._abort.signal;
      this.addEventListener('click', (e) => this.onClick(e), {signal});
      this.addEventListener('keydown', (e) => this.onKeydown(e), {signal});
      this._dialog?.addEventListener('close', () => this.cleanPlayer(), {signal});
      this._dialog?.addEventListener('click', (e) => {
        if (e.target !== this._dialog) return;
        const rect = this._dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this._dialog.close();
      }, {signal});
      this.addEventListener('shopify:block:select', (e) => {
        const id = String(e.detail?.blockId || '');
        const selected = (id && this.querySelector(`[data-block-id="${CSS.escape(id)}"]`)) || e.target;
        const row = selected?.closest?.('details.pc-row');
        if (!row || !this.contains(row)) return;
        row.open = true;
        requestAnimationFrame(() => {
          this.refreshCarousels(row);
          const card = selected?.closest?.('.pc-card');
          const track = card?.closest('.pc-track');
          if (track) {
            const left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
            track.scrollTo({left:Math.max(0,left),behavior:'auto'});
          }
        });
      }, {signal});
      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(() => this.refreshCarousels());
        this._resize.observe(this);
      } else {
        window.addEventListener('resize', () => this.refreshCarousels(), {signal, passive:true});
      }
      this._fileInput = this.querySelector('[data-video-upload]');
      this._fileInput?.addEventListener('change', (e) => this.receiveUpload(e), {signal});
      this.refreshStructure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._startupFrame);
      this._abort?.abort();
      this._resize?.disconnect();
      clearTimeout(this._toastTimer);
      this.cleanPlayer(false);
      this._objectURLs?.forEach(url => URL.revokeObjectURL(url));
      this._ready = false;
    }
    refreshStructure() {
      if (!this._abort || this._abort.signal.aborted) return;
      const signal = this._abort.signal;
      this._rows = [...this.querySelectorAll('details.pc-row[data-expandable="true"]')];
      this._rows.forEach(row => {
        if (this._boundRows.has(row)) return;
        this._boundRows.add(row);
        row.addEventListener('toggle', () => {
          this.syncExpandAll();
          if (row.open) requestAnimationFrame(() => this.refreshCarousels(row));
        }, {signal});
      });
      this.querySelectorAll('.pc-track').forEach(track => {
        if (this._boundTracks.has(track)) return;
        this._boundTracks.add(track);
        track.addEventListener('scroll', () => this.syncCarousel(track), {signal,passive:true});
      });
      for (const track of this._carousels.keys()) {
        if (!this.contains(track)) this._carousels.delete(track);
      }
      this.syncExpandAll();
      requestAnimationFrame(() => this.refreshCarousels());
    }
    onClick(e) {
      const target = e.target.closest('button,a');
      if (!target || !this.contains(target)) return;
      if (target.matches('[data-expand-all]')) {
        const open = !this._rows.every(row => row.open);
        this._rows.forEach(row => {row.open = open;});
        this.syncExpandAll();
      } else if (target.matches('[data-carousel-dir]')) {
        const carousel = target.closest('.pc-carousel');
        this.moveCarousel(carousel, Number(target.dataset.carouselDir));
      } else if (target.matches('[data-carousel-page]')) {
        const carousel = target.closest('.pc-carousel');
        const track = carousel.querySelector('.pc-track');
        const offsets = this._carousels.get(track) || [0];
        track.scrollTo({left:offsets[Number(target.dataset.carouselPage)] || 0, behavior:this.motion()});
      } else if (target.matches('.pc-video-launch')) {
        e.preventDefault();
        const card = target.closest('.pc-card');
        if (!card.querySelector('template')?.content.querySelector('video')) return;
        this._lastFocus = target;
        this._currentCards = [...card.closest('.pc-carousel').querySelectorAll('.pc-card')].filter(c => c.querySelector('template')?.content.querySelector('video'));
        this._currentIndex = this._currentCards.indexOf(card);
        this.openVideo();
      } else if (target.matches('[data-modal-close]')) {
        this._dialog.close();
      } else if (target.matches('[data-modal-dir]')) {
        this._currentIndex = Math.max(0, Math.min(this._currentCards.length - 1, this._currentIndex + Number(target.dataset.modalDir)));
        this.openVideo();
      } else if (target.matches('[data-upload]')) {
        this._uploadCard = target.closest('.pc-card');
        this._fileInput?.click();
      } else if (target.matches('[data-order-now]')) {
        this.handleCTA(e, target);
      }
    }
    motion() {return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';}
    syncExpandAll() {
      const button = this.querySelector('[data-expand-all]');
      const help = this.querySelector('.pc-help');
      if (help) help.hidden = this._rows.length === 0;
      if (!button) return;
      button.hidden = this._rows.length < 2;
      const allOpen = this._rows.length > 0 && this._rows.every(row => row.open);
      button.dataset.allOpen = String(allOpen);
      button.querySelector('span').textContent = allOpen ? 'Collapse all' : 'Expand all';
      button.setAttribute('aria-label', allOpen ? 'Collapse all video carousels' : 'Expand all video carousels');
    }
    onKeydown(e) {
      if (e.target.matches('.pc-track') && ['ArrowLeft','ArrowRight'].includes(e.key)) {
        e.preventDefault();
        this.moveCarousel(e.target.closest('.pc-carousel'), e.key === 'ArrowRight' ? 1 : -1);
      }
    }
    refreshCarousels(scope = this) {
      scope.querySelectorAll('.pc-carousel').forEach(carousel => {
        const track = carousel.querySelector('.pc-track');
        if (!track || track.clientWidth < 1) return;
        const cards = [...track.querySelectorAll('.pc-card')];
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const offsets = [0];
        const tr = track.getBoundingClientRect();
        cards.forEach(card => {
          const raw = card.getBoundingClientRect().left - tr.left + track.scrollLeft - 1;
          const x = Math.round(Math.max(0, Math.min(raw, max)));
          if (x - offsets[offsets.length - 1] > 5) offsets.push(x);
        });
        if (max - offsets[offsets.length - 1] > 5) offsets.push(max);
        this._carousels.set(track, offsets);
        const dots = carousel.querySelector('.pc-dots');
        if (dots && dots.childElementCount !== offsets.length) {
          dots.replaceChildren(...offsets.map((_, i) => {
            const b = document.createElement('button');
            b.type = 'button'; b.className = 'pc-dot'; b.dataset.carouselPage = String(i);
            b.setAttribute('aria-label', `Show video carousel page ${i + 1} of ${offsets.length}`);
            return b;
          }));
        }
        if (dots) dots.hidden = offsets.length < 2;
        const arrows = carousel.querySelector('.pc-carousel-arrows');
        if (arrows) arrows.hidden = offsets.length < 2;
        this.syncCarousel(track);
      });
    }
    carouselIndex(track) {
      const offsets = this._carousels.get(track) || [0];
      return offsets.reduce((best, x, i) => Math.abs(x - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? i : best, 0);
    }
    syncCarousel(track) {
      const carousel = track.closest('.pc-carousel');
      const offsets = this._carousels.get(track) || [0];
      const i = this.carouselIndex(track);
      carousel.querySelectorAll('.pc-dot').forEach((dot, n) => dot.setAttribute('aria-current', String(n === i)));
      const dots = carousel.querySelector('.pc-dots');
      const activeDot = dots?.querySelector('[aria-current="true"]');
      if (dots && activeDot && dots.scrollWidth > dots.clientWidth) {
        const d = dots.getBoundingClientRect();
        const a = activeDot.getBoundingClientRect();
        if (a.left < d.left || a.right > d.right) dots.scrollLeft += a.left - d.left - dots.clientWidth / 2 + a.width / 2;
      }
      const prev = carousel.querySelector('[data-carousel-dir="-1"]');
      const next = carousel.querySelector('[data-carousel-dir="1"]');
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === offsets.length - 1;
    }
    moveCarousel(carousel, direction) {
      if (!carousel) return;
      const track = carousel.querySelector('.pc-track');
      const offsets = this._carousels.get(track) || [0];
      const i = Math.max(0,Math.min(offsets.length - 1,this.carouselIndex(track) + direction));
      track.scrollTo({left:offsets[i],behavior:this.motion()});
    }
    openVideo() {
      const card = this._currentCards[this._currentIndex];
      if (!card || !this._dialog) return;
      const template = card.querySelector('template');
      const player = this._dialog.querySelector('.pc-player');
      this.cleanPlayer(false);
      if (!template) return;
      const fragment = template.content.cloneNode(true);
      const video = fragment.querySelector('video');
      if (!video) return;
      video.controls = true; video.playsInline = true; video.preload = 'metadata';
      video.setAttribute('aria-label', card.querySelector('.pc-card-title')?.textContent || 'Feature video');
      if (video.dataset.demoKey && window.POPC_DEMO_VIDEO_FILES) {
        video.src = window.POPC_DEMO_VIDEO_FILES[video.dataset.demoKey] || '';
      }
      player.replaceChildren(fragment);
      this._dialog.querySelector('.pc-modal-title').textContent = card.querySelector('.pc-card-title')?.textContent || 'A closer look';
      this._dialog.querySelector('.pc-modal-kicker').textContent = card.closest('.pc-row').querySelector('.pc-feature-title')?.textContent || 'The Pop On difference';
      this._dialog.querySelector('.pc-modal-caption').textContent = card.dataset.local === 'true'
        ? 'Your video • Local preview only. Nothing has been uploaded to your store.'
        : (card.dataset.demo === 'true' ? 'Sample animation for testing the layout. Replace with approved brand footage before publishing.' : card.querySelector('.pc-card-subtitle')?.textContent || '');
      this._dialog.querySelector('.pc-modal-nav').hidden = this._currentCards.length < 2;
      this._dialog.querySelector('.pc-modal-counter').textContent = `${this._currentIndex + 1} / ${this._currentCards.length}`;
      this._dialog.querySelector('[data-modal-dir="-1"]').disabled = this._currentIndex === 0;
      this._dialog.querySelector('[data-modal-dir="1"]').disabled = this._currentIndex === this._currentCards.length - 1;
      video.addEventListener('error', () => {
        if (!player.querySelector('.pc-player-error')) {
          const notice = document.createElement('p');
          notice.className = 'pc-player-error';
          notice.textContent = 'This video could not play. Try an H.264 MP4, or check the video source in the theme editor.';
          player.append(notice);
        }
      }, {once:true});
      if (!this._dialog.open) this._dialog.showModal();
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => { /* Native controls remain available when autoplay is restricted. */ });
    }
    cleanPlayer(restoreFocus = true) {
      if (!this._dialog) return;
      this._dialog.querySelectorAll('video').forEach(video => {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(s => s.removeAttribute('src'));
        video.load();
      });
      this._dialog.querySelector('.pc-player')?.replaceChildren();
      if (restoreFocus && this._lastFocus?.isConnected) {
        const row = this._lastFocus.closest('details.pc-row');
        const target = row && !row.open ? row.querySelector('summary') : this._lastFocus;
        target?.focus({preventScroll:true});
      }
    }
    async receiveUpload(e) {
      const file = e.target.files?.[0];
      const card = this._uploadCard;
      e.target.value = '';
      if (!file || !card) return;
      if (file.type && !file.type.startsWith('video/')) {this.toast('Choose a video file such as an MP4.');return;}
      if (file.size > 150 * 1024 * 1024) {this.toast('For this local preview, choose a video smaller than 150 MB.');return;}
      const url = URL.createObjectURL(file);
      this._objectURLs.add(url);
      if (card.dataset.objectUrl) {URL.revokeObjectURL(card.dataset.objectUrl);this._objectURLs.delete(card.dataset.objectUrl);}
      card.dataset.objectUrl = url; card.dataset.local = 'true'; card.dataset.demo = 'false';
      const template = card.querySelector('template');
      const video = document.createElement('video');
      video.src = url; video.controls = true; video.playsInline = true; video.preload = 'none';
      template.content.replaceChildren(video);
      const badge = card.querySelector('.pc-preview-badge');
      if (badge) badge.textContent = 'Your video';
      const probe = document.createElement('video');
      probe.muted = true; probe.playsInline = true; probe.preload = 'auto'; probe.src = url;
      probe.addEventListener('loadedmetadata', () => {
        const seconds = Math.round(probe.duration);
        const duration = card.querySelector('.pc-duration');
        if (duration && Number.isFinite(seconds)) duration.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2,'0')}`;
        if (probe.duration > .1) probe.currentTime = Math.min(.1,probe.duration / 2);
      }, {once:true});
      probe.addEventListener('seeked', () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = 640;
          canvas.height = Math.max(1,Math.round(640 * probe.videoHeight / probe.videoWidth));
          canvas.getContext('2d').drawImage(probe,0,0,canvas.width,canvas.height);
          const img = document.createElement('img');
          img.src = canvas.toDataURL('image/jpeg',.85);img.alt='Preview frame from your locally selected video';
          const poster = card.querySelector('.pc-poster');
          poster.querySelector('img')?.remove();poster.prepend(img);
          video.poster=img.src;
        } catch (_) { /* A thumbnail is optional; the video remains playable. */ }
        probe.removeAttribute('src');probe.load();
      }, {once:true});
      this.toast('Video added to this preview only. Your file stays in this browser session.');
    }
    handleCTA(e, link) {
      if (this.dataset.preview === 'true') {
        e.preventDefault();this.toast('Preview only — Get Started will lead to your product options on Shopify.');return;
      }
      if (this.dataset.ctaMode === 'scroll') {
        let form;
        try {form = document.querySelector(this.dataset.formSelector || 'form[action*="/cart/add"]');} catch (_) {form = document.querySelector('form[action*="/cart/add"]');}
        if (form) {
          e.preventDefault();form.scrollIntoView({behavior:this.motion(),block:'center'});
          const focusable = [...form.querySelectorAll('select, input:not([type="hidden"]), button')].find(node => !node.disabled && node.getClientRects().length);
          if (focusable) focusable.focus({preventScroll:true});
        } else if (!link.getAttribute('href') || link.getAttribute('href') === '#') {
          e.preventDefault();this.toast('Set the Get Started link or product-form selector in the theme editor.');
        }
      } else if (link.getAttribute('href') === '#') {
        e.preventDefault();this.toast('Set the Get Started destination in the theme editor.');
      }
    }
    toast(message) {
      const toast = this.querySelector('.pc-toast');
      if (!toast) return;
      toast.textContent = message;toast.hidden=false;
      clearTimeout(this._toastTimer);this._toastTimer=setTimeout(() => {toast.hidden=true;},5000);
    }
  }
  customElements.define('pop-on-comparison-v4',PopOnComparison);
})();

  } catch(e) { console.error(e); }
})();
})();
